import { registerPlugin } from '@capacitor/core';

/**
 * WebView の画面上レイアウト情報を取得するプラグイン（Android のみ）。
 * CameraPreview と同じ edge-to-edge 判定を返す。
 */
export const WebViewLayout = registerPlugin('WebViewLayout');
